import React from 'react';

import FindFilters from '../../../../activ8/find/filters/FindFilters';
import ContentList from '../../../../activ8/find/content-list/ContentList';

import scss from './Find.module.scss';

function Find() {
  return (
    <div className={scss.wrapper}>
      <FindFilters />

      <ContentList />
    </div>
  );
}

export default Find;
